export default __webpack_public_path__ + "static/media/PLU-UK-OWON.fdc0a768.png";